export default function PageHeader({ title, subtitle, actions, testId }) {
  return (
    <div className="px-4 sm:px-6 md:px-8 py-4 md:py-6 border-b border-nhp-border bg-nhp-bg md:sticky md:top-0 z-10">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 md:gap-4">
        <div data-testid={testId} className="min-w-0">
          <h1 className="font-heading font-black text-xl md:text-2xl tracking-tight leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm text-nhp-muted mt-1.5">{subtitle}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
      </div>
    </div>
  );
}
